import styled from 'styled-components'
import { StyledIconProps } from './Icon.types'

const sizeMap = {
  xs: '12px',
  small: '16px',
  medium: '20px',
  large: '24px',
  xl: '32px',
}

export const StyledIcon = styled.svg<StyledIconProps>`
  width: ${(props) =>
    typeof props.$size === 'number'
      ? `${props.$size}px`
      : sizeMap[props.$size as keyof typeof sizeMap]};
  height: ${(props) =>
    typeof props.$size === 'number'
      ? `${props.$size}px`
      : sizeMap[props.$size as keyof typeof sizeMap]};
  stroke: ${(props) => props.$color || 'currentColor'};
  stroke-width: ${(props) =>
    props.$strokeWidth ? `${props.$strokeWidth}px` : '1.5'};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`
